export async function tryParseResponseError(res: Response) {
  try {
    const json = await res.json();
    let message = "Etwas ist fehlgeschlagen";
    if (json.message) {
      message = json.message;
    }
    if (json.errors) {
      message = json.errors.join(", ");
    }
    if (json.error) {
      message = json.error;
    }
    return message;
  } catch (e) {
    return res.statusText ? `${res.status}: ${res.statusText}` : "Etwas ist fehlgeschlagen";
  }
}
